import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  OnDestroy,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NgbModal, NgbRatingConfig } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { GlobalVariable } from "../app.component";
import { DataService, Response } from "../dataService/data.service";
import { CommonService } from "../services/common.service";

@Component({
  selector: "app-review-experience",
  templateUrl: "./review-experience.component.html",
  styleUrls: ["./review-experience.component.scss"],
})
export class ReviewExperienceComponent implements OnInit, OnDestroy {
  @ViewChild("errorModal", { static: true }) errorModal: ElementRef;
  @ViewChild("zceppaReviewModal", { static: true })
  zceppaReviewModal: ElementRef;
  @ViewChild("thankyoumodal", { static: true }) thankyoumodal: ElementRef;
  public loading = false;
  isSubmitClicked: boolean;
  slug_has_feedback: any;

  linkValid: boolean = false;
  reviewsby = [];
  messageSuccess: boolean = false;
  private BASE_URL = GlobalVariable;
  slug_value: string;
  error_slug: boolean = false;
  success_slug: boolean = false;
  error_message: String;
  // success_data: any;
  feedback: String;
  selected_rating: number = 0;
  ratings: number = 0;
  readonly: boolean = false;
  logo_url: String;
  business_name: String;
  customer_name: String;
  load_zceppa: boolean;
  redirect_reviews_page: any = [];
  redirect_reviews_page_g: any = [];
  redirect_reviews_page_f: any = [];
  redirect_reviews_page_z: any = [];
  redirect_reviews_page_zomato: any = [];
  redirect_reviews_page_trip_advisor: any = [];
  redirect_reviews_page_practo: any = [];
  redirect_reviews_page_just_dail: any = [];
  redirect_reviews_page_amazon: any = [];
  show_pages: boolean = false;
  fromNegativePage: boolean = false;
  optionForWhatsApp: any;

  isAutoRedirectSet: boolean = false;
  showPoweredBy: boolean = false;
  skipFeedbackStep: boolean = false;
  private redirectFallbackTimer: any = null;
  private readonly REDIRECT_FALLBACK_MS = 8000;

  constructor(
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private HttpService: DataService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private toastrService: ToastrService,
    private commonservice: CommonService,
    config: NgbRatingConfig
  ) {
    config.max = 5;
    config.readonly = true;
  }

  ngOnInit() {
    this.loading = true;

    // When the rating step was skipped, this component is only a staging post on the
    // way to the review platform — keep its markup hidden from the first frame so the
    // platform picker never flashes before the redirect fires.
    this.commonservice.skip_feedback_step.subscribe((skip: boolean) => {
      if (skip) {
        this.skipFeedbackStep = true;
        this.isAutoRedirectSet = true;
      }
    });

    this.commonservice.commonData.subscribe((data: any) => {
      if (data != null) {
        this.business_name = data["business_name"];
        this.logo_url = data["business_logo"];
        this.customer_name = data["contact_name"];
        this.showPoweredBy = data["show_powered_by_logo"];
        this.success_slug = true;
        this.error_slug = false;

        if (
          data["google"] !== undefined &&
          data["google"].google_link !== null
        ) {
          this.reviewsby.push({
            id: 1,
            reviewby: "Google",
            image: "assets/images/social/google.png",
            class: "reviewgoogle  ",
            link: data["google"].google_link,
            source: true,
          });
          this.redirect_reviews_page.push({ url: data["google"].google_link });
          this.redirect_reviews_page_g.push({
            url: data["google"].google_link,
          });
        }
        if (
          data["facebook"] !== undefined &&
          data["facebook"].fb_link !== null
        ) {
          this.reviewsby.push({
            id: 2,
            reviewby: "Facebook",
            image: "assets/images/social/facebook.png",
            class: "reviewfacebook  ",
            link: data["facebook"].fb_link,
            source: true,
          });
          this.redirect_reviews_page.push({ url: data["facebook"].fb_link });
          this.redirect_reviews_page_f.push({ url: data["facebook"].fb_link });
        }
        if (data["custom"] !== undefined) {
          data["custom"].forEach((val: any, key: any) => {
            if (val.url !== null) {
              this.redirect_reviews_page.push({ url: val.url });
            }
            if (val.type === "zomato") {
              this.reviewsby.push({
                id: 3,
                reviewby: "Zomato",
                image: "assets/images/zomato_white_logo_new.svg",
                class: "reviewzomato  ",
                link: val.url,
                source: true,
              });
              this.redirect_reviews_page_zomato.push({ url: val.url });
            }
            if (val.type === "trip_advisor") {
              this.reviewsby.push({
                id: 4,
                reviewby: "TripAdvisor",
                image: "assets/images/tripadvisor.svg",
                class: "reviewtrip  ",
                link: val.url,
                source: true,
              });
              this.redirect_reviews_page_trip_advisor.push({ url: val.url });
            }
            if (val.type === "practo") {
              this.reviewsby.push({
                id: 5,
                reviewby: "Practo",
                image: "assets/images/practo.svg",
                class: "reviewpracto  ",
                link: val.url,
                source: true,
              });
              this.redirect_reviews_page_practo.push({ url: val.url });
            }
            if (val.type === "just_dail") {
              this.reviewsby.push({
                id: 6,
                reviewby: "Just Dial",
                image: "assets/images/jdlogosvg.svg",
                class: "reviewjustdial  ",
                link: val.url,
                source: true,
              });
              this.redirect_reviews_page_just_dail.push({ url: val.url });
            }
            if (val.type === "amazon") {
              this.reviewsby.push({
                id: 7,
                reviewby: "Amazon",
                image: "assets/images/amazon-logo.svg",
                class: "reviewjustdial  ",
                link: val.url,
                source: true,
              });
              this.redirect_reviews_page_amazon.push({ url: val.url });
            }
          });
        }
        // Show zceppa platform if external review platform is not available
        // this.slug_has_feedback = data["slug_has_feedback"];
        // this.load_zceppa = data["zceppa"].load_zceppa;
        let isExternalPlatformAvailable = this.reviewsby?.some(
          (platform) => platform.source && platform.link !== null
        );

        if (!isExternalPlatformAvailable) {
          this.reviewsby.push({
            id: 8,
            reviewby: "Zceppa",
            image: "assets/images/favicon.png",
            class: "reviewzceppa  ",
            link: "INTERNAL",
            source: true,
          });
        }
        // On the skip path the loader must stay up all the way to the redirect,
        // otherwise it blinks off for a frame before the redirect fires.
        if (!this.skipFeedbackStep) {
          this.loading = false;
        }

        const auto_redirect = this.storage.get("auto_redirect");

        if (auto_redirect && auto_redirect != "null") {
          const redirectUrl = this.getAutoRedirectUrl(auto_redirect);

          if (!redirectUrl) {
            // Outlet auto-redirects to a platform it has no link for. Fall back to
            // the picker rather than stranding the consumer on a spinner.
            this.cancelAutoRedirect();
          } else {
            this.loading = true;
            // to hide the screen when auto redirect
            this.isAutoRedirectSet = true;

            // Backstop: if the redirect is blocked (in-app browsers can swallow it),
            // drop back to the picker instead of spinning forever.
            this.redirectFallbackTimer = setTimeout(() => {
              this.cancelAutoRedirect();
            }, this.REDIRECT_FALLBACK_MS);

            setTimeout(() => {
              this.postReviewBy(redirectUrl);
            }, 0);
          }
        } else if (this.skipFeedbackStep) {
          // Skip was requested but no auto-redirect target is configured.
          this.cancelAutoRedirect();
        }
      }
    });

    this.commonservice.is_from_negative_feedback.subscribe(
      (fromNegativePage) => {
        if (fromNegativePage) {
          this.fromNegativePage = true;
        }
      }
    );
    this.commonservice.getData();
  }

  /**
   * Resolve the configured auto-redirect platform to its review URL.
   * Returns null when the outlet has no link for that platform.
   */
  private getAutoRedirectUrl(auto_redirect: string): string | null {
    const targets = {
      google: this.redirect_reviews_page_g,
      facebook: this.redirect_reviews_page_f,
      zomato: this.redirect_reviews_page_zomato,
      trip_advisor: this.redirect_reviews_page_trip_advisor,
      practo: this.redirect_reviews_page_practo,
      just_dail: this.redirect_reviews_page_just_dail,
      amazon: this.redirect_reviews_page_amazon,
    };

    return targets[auto_redirect]?.[0]?.url || null;
  }

  /**
   * Abandon the auto-redirect and show the platform picker instead.
   */
  private cancelAutoRedirect(): void {
    this.clearRedirectFallback();
    this.loading = false;
    this.isAutoRedirectSet = false;
  }

  private clearRedirectFallback(): void {
    if (this.redirectFallbackTimer) {
      clearTimeout(this.redirectFallbackTimer);
      this.redirectFallbackTimer = null;
    }
  }

  ngOnDestroy() {
    this.clearRedirectFallback();
  }

  /**
   * Post review link
   *
   * @param {*} link
   * @memberof ReviewExperienceComponent
   */
  postReviewBy(link) {
    if (link === "INTERNAL") {
      this.cancelAutoRedirect();
      this.ZceppaReviewModal();
    } else {
      this.openLink(link);
    }
  }

  private openLink(url: string): void {
    const ua = navigator.userAgent || "";
    const isWhatsApp =
      /WhatsApp/i.test(ua) ||
      /\[WAiOS\//i.test(ua) ||
      /\[WABIZ\//i.test(ua) ||
      /WA4A\//i.test(ua);
    const isAndroid = /Android/i.test(ua);
    const stripped = url.replace(/^https?:\/\//, "");

    if (isWhatsApp && !this.fromNegativePage && isAndroid) {
      const fallback = encodeURIComponent(url);
      window.location.href = `intent://${stripped}#Intent;scheme=https;package=com.android.chrome;S.browser_fallback_url=${fallback};end`;
    } else if (isWhatsApp && !this.fromNegativePage) {
      window.location.href = `x-safari-https://${stripped}`;
    } else {
      window.location.replace(url);
    }
  }

  ZceppaReviewModal() {
    this.modalService.open(this.zceppaReviewModal, {
      size: "sm",
      windowClass: "modalfeedback",
      centered: true,
    });
  }
  optedinWhatsApp(optionForWhatsApp) {
    this.route.params.forEach((val) => {
      this.slug_value = val["id"];
    });
    var data_json = {
      is_optin: optionForWhatsApp,
    };
    const data_service = this.HttpService.put(
      this.BASE_URL.OPTIN(this.slug_value),
      data_json
    );
    data_service.subscribe(
      (data: Response) => {
        console.log(data);
        //  this.toastrService.success(data.data['message']);
      },
      (error) => {
        this.toastrService.warning(error.error.message);
      },
      () => {}
    );
  }

  thankyouModal() {
    let res: Response;
    this.route.params.forEach((val) => {
      this.slug_value = val["id"];
    });
    if (this.feedback === undefined || this.feedback === "") {
      this.toastrService.error("Please Enter Feedback");
      return;
    }
    if (this.selected_rating === 0) {
      this.toastrService.error("Please Choose Ratings");
      return;
    }
    this.isSubmitClicked = true;
    const json_data = {
      slug: this.slug_value,
      feedback_text: this.feedback,
      feedback_star: this.selected_rating,
    };
    const data_service = this.HttpService.postjson(
      this.BASE_URL.SMS_SLUG_REQUEST_URL,
      json_data
    );
    data_service.subscribe(
      (data: Response) => {
        res = data;
      },
      (error) => {
        this.isSubmitClicked = false;
      },
      () => {
        this.isSubmitClicked = false;
        if (res.code === 200 || res.code === 201) {
          this.modalService.dismissAll(this.zceppaReviewModal);
          this.showThankyouModal();
          this.feedback = "";
        } else {
          this.toastrService.error(res.data["message"]);
        }
      }
    );
  }

  showThankyouModal() {
    this.modalService.open(this.thankyoumodal, {
      size: "sm",
      windowClass: "modalfeedback",
      centered: true,
    });
  }

  closeModal() {
    this.modalService.dismissAll(this.thankyoumodal);
  }

  /**
   *Common toastr for success function
   *
   * @param {string} msg
   * @memberof ReviewExperienceComponent
   */
  showSuccess(msg: string) {
    this.toastrService.success(msg);
  }

  /**
   * Common toastr for error function
   *
   * @param {string} msg
   * @memberof ReviewExperienceComponent
   */
  showError(msg: string) {
    this.toastrService.error(msg);
  }
}
